import React from "react";
import {
    Box,
    Card,
    CardActions,
    CardContent,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from "@mui/material";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { useNavigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";

export default function UserSettings() {
    const navigate = useNavigate();
    const handleUserDetails = () => {
        navigate("details");
    };

    const handleManagePlatforms = () => {
        navigate("manage-links");
    };

    // const theme = createTheme({
    //     palette: {
    //         secondary: {
    //             main: '#EEEEEE'
    //         }
    //     }
    // });
    return (
        <Box sx={{ borderRadius: 2, boxShadow: 24, width: "100%" }}>
            <Card
                sx={{ minWidth: "100%", p: 1, backgroundColor: "primary.main" }}
            >
                <CardContent sx={{ p: 0, m: 1 }}>
                    <Typography variant="h6">Edit your profile</Typography>
                    <Typography variant="body1">
                        Change your account settings and information
                    </Typography>
                </CardContent>
                <CardActions
                    variant="outlined"
                    sx={{
                        py: 0,
                        px: 0,
                        borderTop: "1px grey solid",
                        borderRadius: "0 0 5px 5px",
                    }}
                >
                    <List sx={{ width: "100%", p: 0 }}>
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={handleUserDetails}
                                sx={{ p: 1 }}
                                divider
                            >
                                <ListItemIcon>
                                    <ManageAccountsIcon />
                                </ListItemIcon>
                                <ListItemText primary="view or change your details" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton
                                sx={{ p: 1 }}
                                onClick={handleManagePlatforms}
                            >
                                <ListItemIcon>
                                    <AccountTreeIcon />
                                </ListItemIcon>
                                <ListItemText primary="manage your linked platforms" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </CardActions>
            </Card>
        </Box>
    );
}
